<template>
  <i
    class="info-icon"
    :style="iconStyle"
    @click="handleClick"
  >
    i
  </i>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator'

@Component
export default class InfoIcon extends Vue {
  @Prop() background: string
  @Prop() color: string
  @Prop({ default: 'pointer' }) cursor: string

  get iconStyle (): string {
    let style = `cursor: ${this.cursor};`
    if (this.background) style += `background: ${this.background};`
    if (this.color) style += `color: ${this.color};`
    return style
  }

  handleClick () {
    this.$emit('onClick')
  }
}
</script>
<style lang="scss" scoped>
.info-icon {
  font-style: normal;
  width: 25px;
  height: 25px;
  display: inline-block;
  font-size: 19px;
  text-align: center;
  line-height: 22px;
  border-radius: 50%;
  background-image: linear-gradient(90deg, var(--v-purple-base), var(--v-purple-lighten2));
  color: #fff;
  font-weight: 300;
}
</style>
